module.exports = {
          srcSet: __webpack_public_path__ + "0ab8210c11b00f542f3c7ad14dfff58c-70.png"+" 70w",
          images:[ {path: __webpack_public_path__ + "0ab8210c11b00f542f3c7ad14dfff58c-70.png",width: 70,height: 54}],
          src: __webpack_public_path__ + "0ab8210c11b00f542f3c7ad14dfff58c-70.png",
          toString:function(){return __webpack_public_path__ + "0ab8210c11b00f542f3c7ad14dfff58c-70.png"},
          
          width: 70,
          height: 54
        }